const getDistancesInMeters = (distance, distanceUnit) => {
    if (distanceUnit === 'km') {
        return distance * 1000;
    }
    return Number((distance / 0.000621371).toFixed(2));
};

export default getDistancesInMeters;
